import NavLinkItem from "./NavLinkItem";
import { NAV_ITEMS } from "./navItems";

/**
 * Desktop primary navigation row.
 */
export default function DesktopNav({ onAnchorClick }) {
  return (
    <nav data-testid="primary-nav" className="hidden lg:flex items-center gap-5 xl:gap-7">
      {NAV_ITEMS.map((item) => (
        <NavLinkItem key={item.label} item={item} onAnchorClick={onAnchorClick} />
      ))}
    </nav>
  );
}
